export default __webpack_public_path__ + "static/media/clip-light.d94f8396.svg";